// Copyright (c) 2023 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/assistant/v4/assistant.proto (package wisetime.user.assistant.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/assistant/v4/assistant.proto.
 */
export const file_wisetime_user_assistant_v4_assistant: GenFile = /*@__PURE__*/
  fileDesc("Cip3aXNldGltZS91c2VyL2Fzc2lzdGFudC92NC9hc3Npc3RhbnQucHJvdG8SGndpc2V0aW1lLnVzZXIuYXNzaXN0YW50LnY0IjoKGEdlbmVyYXRlTmFycmF0aXZlUmVxdWVzdBIeChZ1bnBvc3RlZF90aW1lX2dyb3VwX2lkGAEgASgJIkIKGUdlbmVyYXRlTmFycmF0aXZlUmVzcG9uc2USEQoJbmFycmF0aXZlGAEgAygJEhIKCm1vZGVsX25hbWUYAiABKAkinwEKGkJhdGNoVHJhbnNsYXRlVGV4dHNSZXF1ZXN0EkIKC3RvX2xhbmd1YWdlGAEgASgOMi0ud2lzZXRpbWUudXNlci5hc3Npc3RhbnQudjQuVHJhbnNsYXRlTGFuZ3VhZ2USPQoMdHJhbnNsYXRpb25zGAIgAygLMicud2lzZXRpbWUudXNlci5hc3Npc3RhbnQudjQuVHJhbnNsYXRpb24iXAobQmF0Y2hUcmFuc2xhdGVUZXh0c1Jlc3BvbnNlEj0KDHRyYW5zbGF0aW9ucxgBIAMoCzInLndpc2V0aW1lLnVzZXIuYXNzaXN0YW50LnY0LlRyYW5zbGF0aW9uIigKC1RyYW5zbGF0aW9uEgsKA2tleRgBIAEoCRIMCgR0ZXh0GAIgASgJKnQKEVRyYW5zbGF0ZUxhbmd1YWdlEiIKHlRSQU5TTEFURV9MQU5HVUFHRV9VTlNQRUNJRklFRBAAEgkKBURVVENIEAESCwoHRU5HTElTSBACEgoKBkZSRU5DSBADEgoKBkdFUk1BThAEEgsKB1NQQU5JU0gQBTKeAgoQQXNzaXN0YW50U2VydmljZRKAAQoRR2VuZXJhdGVOYXJyYXRpdmUSNC53aXNldGltZS51c2VyLmFzc2lzdGFudC52NC5HZW5lcmF0ZU5hcnJhdGl2ZVJlcXVlc3QaNS53aXNldGltZS51c2VyLmFzc2lzdGFudC52NC5HZW5lcmF0ZU5hcnJhdGl2ZVJlc3BvbnNlEoYBChNCYXRjaFRyYW5zbGF0ZVRleHRzEjYud2lzZXRpbWUudXNlci5hc3Npc3RhbnQudjQuQmF0Y2hUcmFuc2xhdGVUZXh0c1JlcXVlc3QaNy53aXNldGltZS51c2VyLmFzc2lzdGFudC52NC5CYXRjaFRyYW5zbGF0ZVRleHRzUmVzcG9uc2VCPQoiY29tLndpc2V0aW1lLmFwaS51c2VyLmFzc2lzdGFudC52NEIVQXNzaXN0YW50U2VydmljZVByb3RvUAFiBnByb3RvMw");

/**
 * @generated from message wisetime.user.assistant.v4.GenerateNarrativeRequest
 */
export type GenerateNarrativeRequest = Message<"wisetime.user.assistant.v4.GenerateNarrativeRequest"> & {
  /**
   * @generated from field: string unposted_time_group_id = 1;
   */
  unpostedTimeGroupId: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.GenerateNarrativeRequest.
 * Use `create(GenerateNarrativeRequestSchema)` to create a new message.
 */
export const GenerateNarrativeRequestSchema: GenMessage<GenerateNarrativeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_assistant, 0);

/**
 * @generated from message wisetime.user.assistant.v4.GenerateNarrativeResponse
 */
export type GenerateNarrativeResponse = Message<"wisetime.user.assistant.v4.GenerateNarrativeResponse"> & {
  /**
   * instruct gpt returns 0-2 responses.
   * api will return single narrative in normal case
   * front-end should show first value or empty string if empty (could later have option for user to pick/switch)
   *
   * @generated from field: repeated string narrative = 1;
   */
  narrative: string[];

  /**
   * the model variant used to generate the narrative, e.g. Concise, Formal A, Formal B
   *
   * @generated from field: string model_name = 2;
   */
  modelName: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.GenerateNarrativeResponse.
 * Use `create(GenerateNarrativeResponseSchema)` to create a new message.
 */
export const GenerateNarrativeResponseSchema: GenMessage<GenerateNarrativeResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_assistant, 1);

/**
 * @generated from message wisetime.user.assistant.v4.BatchTranslateTextsRequest
 */
export type BatchTranslateTextsRequest = Message<"wisetime.user.assistant.v4.BatchTranslateTextsRequest"> & {
  /**
   * ISO 639-1 language code.
   *
   * @generated from field: wisetime.user.assistant.v4.TranslateLanguage to_language = 1;
   */
  toLanguage: TranslateLanguage;

  /**
   * @generated from field: repeated wisetime.user.assistant.v4.Translation translations = 2;
   */
  translations: Translation[];
};

/**
 * Describes the message wisetime.user.assistant.v4.BatchTranslateTextsRequest.
 * Use `create(BatchTranslateTextsRequestSchema)` to create a new message.
 */
export const BatchTranslateTextsRequestSchema: GenMessage<BatchTranslateTextsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_assistant, 2);

/**
 * @generated from message wisetime.user.assistant.v4.BatchTranslateTextsResponse
 */
export type BatchTranslateTextsResponse = Message<"wisetime.user.assistant.v4.BatchTranslateTextsResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.assistant.v4.Translation translations = 1;
   */
  translations: Translation[];
};

/**
 * Describes the message wisetime.user.assistant.v4.BatchTranslateTextsResponse.
 * Use `create(BatchTranslateTextsResponseSchema)` to create a new message.
 */
export const BatchTranslateTextsResponseSchema: GenMessage<BatchTranslateTextsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_assistant, 3);

/**
 * @generated from message wisetime.user.assistant.v4.Translation
 */
export type Translation = Message<"wisetime.user.assistant.v4.Translation"> & {
  /**
   * Client-supplied key.
   * The server will use the key when responding with the translated text, so that the client knows what was translated.
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.Translation.
 * Use `create(TranslationSchema)` to create a new message.
 */
export const TranslationSchema: GenMessage<Translation> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_assistant, 4);

/**
 * @generated from enum wisetime.user.assistant.v4.TranslateLanguage
 */
export enum TranslateLanguage {
  /**
   * @generated from enum value: TRANSLATE_LANGUAGE_UNSPECIFIED = 0;
   */
  TRANSLATE_LANGUAGE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DUTCH = 1;
   */
  DUTCH = 1,

  /**
   * @generated from enum value: ENGLISH = 2;
   */
  ENGLISH = 2,

  /**
   * @generated from enum value: FRENCH = 3;
   */
  FRENCH = 3,

  /**
   * @generated from enum value: GERMAN = 4;
   */
  GERMAN = 4,

  /**
   * @generated from enum value: SPANISH = 5;
   */
  SPANISH = 5,
}

/**
 * Describes the enum wisetime.user.assistant.v4.TranslateLanguage.
 */
export const TranslateLanguageSchema: GenEnum<TranslateLanguage> = /*@__PURE__*/
  enumDesc(file_wisetime_user_assistant_v4_assistant, 0);

/**
 * @generated from service wisetime.user.assistant.v4.AssistantService
 */
export const AssistantService: GenService<{
  /**
   * Generate time group narrative via ChatGPT.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    unposted_time_group_id is required
   * - NOT_FOUND:           The time group does not exist
   * - FAILED_PRECONDITION: The time group has already been posted
   *
   * If the time group is empty, the RPC will simply return an empty narrative.
   *
   * @generated from rpc wisetime.user.assistant.v4.AssistantService.GenerateNarrative
   */
  generateNarrative: {
    methodKind: "unary";
    input: typeof GenerateNarrativeRequestSchema;
    output: typeof GenerateNarrativeResponseSchema;
  },
  /**
   * Translate texts to specific language.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    to_language is required and at least one translation item is required
   *
   * @generated from rpc wisetime.user.assistant.v4.AssistantService.BatchTranslateTexts
   */
  batchTranslateTexts: {
    methodKind: "unary";
    input: typeof BatchTranslateTextsRequestSchema;
    output: typeof BatchTranslateTextsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_assistant_v4_assistant, 0);

